export default __webpack_public_path__ + "static/media/fax.bf8ff179.png";